import React, { useCallback } from "react";
import { connect } from "react-redux";

import { faEllipsisH } from "@fortawesome/pro-solid-svg-icons/faEllipsisH";
import { faExclamationCircle } from "@fortawesome/pro-solid-svg-icons/faExclamationCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import { Button, Dropdown, showModal } from "@mapmycustomers/ui";

import styles from "@app/component/EmailQueueModal/EmailQueueActions.module.scss";
import { getEmailQuota } from "@app/store/email";
import { clearEmailQueue } from "@app/store/email/actions";
import { RootState } from "@app/store/rootReducer";

import messages from "./messages";

const EmailQueueActions = ({
  emailQuota,
  onClearQueue,
}: ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps) => {
  const intl = useIntl();

  const handleClearQueue = useCallback(() => {
    return new Promise<void>((resolve) => {
      onClearQueue({
        finishCallback: resolve,
      });
    });
  }, [onClearQueue]);

  const handleClearQueueClick = useCallback(() => {
    showModal({
      autoFocusButton: null,
      cancelButtonProps: {
        type: "default",
      },
      cancelText: intl.formatMessage(messages.goBackLabel),
      centered: true,
      closable: false,
      content: (
        <div className={styles.confirmDescription}>
          {intl.formatMessage(messages.clearQueueModalDescription)}
        </div>
      ),
      icon: <FontAwesomeIcon icon={faExclamationCircle} />,
      okButtonProps: {
        danger: true,
        type: "default",
      },
      okText: intl.formatMessage(messages.clearQueueLabel),
      onOk: handleClearQueue,
      title: intl.formatMessage(messages.clearQueueModalTitle),
      type: "confirm",
    });
  }, [intl, handleClearQueue]);

  if (emailQuota && !emailQuota.submitted) {
    return null;
  }

  return (
    <Dropdown
      menu={{
        items: [
          {
            className: styles.clearQueue,
            key: "clearQueue",
            label: intl.formatMessage(messages.clearQueueLabel),
            onClick: handleClearQueueClick,
          },
        ],
      }}
      trigger={["click"]}
    >
      <Button
        leftIcon={<FontAwesomeIcon className={styles.menuIcon} icon={faEllipsisH} />}
        loading={!emailQuota}
        type="link"
      />
    </Dropdown>
  );
};

const mapStateToProps = (state: RootState) => ({
  emailQuota: getEmailQuota(state),
});

const mapDispatchToProps = {
  onClearQueue: clearEmailQueue,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailQueueActions);
